import { baseColors } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center"
    },
    card: {
        overflow: "hidden",
        height: 100,
        width: "100%",
        borderRadius: 10
    },
    icon: { alignSelf: "flex-end" },
    title: { marginHorizontal: 15 },
    cardContainer: { width: "100%", marginVertical: 8, borderRadius: 10, marginBottom: 5 },
    statusLabel: {
        paddingHorizontal: 25,
        paddingVertical: 5,
        backgroundColor: "white",
        alignItems: "center",
        borderRadius: 20,
        textTransform: "uppercase",
        color: baseColors.green.dark
    },
    statusLabelContainer: {
        marginTop: 25,
        marginLeft: 15,
        flexDirection: "row"
    }
})

export default styles
